import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import Button from './Button';
import useTranslate from '../customHooks/useTranslate';

const PopUp = props => {
    const {
        children,
        titleText,
        onSave,
        onCancel,
        saveText = 'save',
        cancelText = 'cancel',
        saveButonProps,
        cancelButtonProps,
        open,
        className,
        PaperProps,
        actions,
        ...restProps
    } = props;
    const title = useTranslate(titleText);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isMounted, setIsMounted] = useState(true);

    useEffect(() => {
        setIsMounted(true);
        return () => {
            setIsMounted(false);
        };
    }, []);

    const handleAction = async action => {
        setIsDisabled(true);
        await action();
        if (isMounted) {
            setIsDisabled(false);
        }
    };

    const dialogPaperProps = {
        ...PaperProps,
        className: [PaperProps?.className, className].filter(Boolean).join(' '),
    };

    return (
        <Dialog
            open={open}
            {...restProps}
            className={className}
            PaperProps={dialogPaperProps}
        >
            {titleText && <DialogTitle>{title}</DialogTitle>}
            <DialogContent>{children}</DialogContent>
            {actions}
            {!actions && (onSave || onCancel) && (
                <DialogActions sx={{ padding: '20px' }}>
                    {onCancel && (
                        <Button
                            variant='outlined'
                            onClick={() => handleAction(onCancel)}
                            disabled={isDisabled}
                            {...cancelButtonProps}
                        >
                            {cancelText}
                        </Button>
                    )}
                    {onSave && (
                        <Button
                            variant='contained'
                            onClick={() => handleAction(onSave)}
                            disabled={isDisabled}
                            {...saveButonProps}
                        >
                            {saveText}
                        </Button>
                    )}
                </DialogActions>
            )}
        </Dialog>
    );
};

export default PopUp;
